<template>
	<toolbar>
		<router-link to="/financial" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2>Financial</h2>
		</router-link>
		
		<div class="controls">
			<nav-tabs :tabs="expensesTabs" :mobile-breakpoint="mobileBreakpoint"></nav-tabs>
		</div>
	</toolbar>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

export default {
	name: "ExpenseToolbar",
	props: ["heading","icon"],
	components: {
		Toolbar,
		NavTabs
	},
	data() {
		return {
			mobileBreakpoint: 800,
			expensesTabs: [
				
				{
					label: "Review",
					icon: "fa-eye",
					path: "/expenses/review",
				},
				{
					label: "Submitted Expenses",
					icon: "fa-history",
					path: "/expenses/submitted",
				},
				{
					label: "List",
					icon: "fa-list",
					path: "/expenses/list",
				},
				{
					label: "Submit New",
					icon: "fa-plus",
					path: "/expenses/submit-new",
				}
			]
		}
	}
}
</script>